import React, { Children, useEffect, useState } from 'react';
import { Modal, ModalTitle, ModalBody } from "@vds3/modals";
import { Body } from '@vds3/typography';
import { Input } from '@vds3/inputs';
import { MarginSpacerL, MarginSpacerM } from './Pages/CustomizeOrder/TVServiceComponent/styleTag';
import { Button } from "@vds3/buttons";
import ReCAPTCHA from "react-google-recaptcha";
import { GOOGLE_RECAPTCHA_SITEKEY } from './containers/constants';
import { connect } from 'react-redux';
import { validateEmail } from './containers/actions';
import SpinnerComponent from './Common/Spinner/Spinner';
import { useTranslation } from 'react-i18next';
import { CheckAEMBoolValue } from './Common/CommonPlanTile/CommonPlanTile';


const SaveCartValidationModal = (props) => {
    const {t,ready} = useTranslation(['fios'])
    const [recaptchaValue, setRecaptchaValue] = React.useState('');
    const [error, setError] = React.useState(false);
    const [errorText, setErrorText] = React.useState('');
    const [email, setEmail] = React.useState('');
   
    useEffect(() => {
        if (props.emailValidation === false) {
            setError(true)
            setErrorText(t("fios.saveCartErrorMessage",{ns:'fios'}))
        }
    }, [props.emailValidation])
    const validateEmail = (val) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (regex.test(email)) {
            setError(false)
            setErrorText("")
        } else {
            setError(true)
            setErrorText("Enter valid email")
        }
        setEmail(val)

    }
    const handleContinue = () => {
        const values = window.location.search
        const scart = String(values).split("scartid=")
        const scartFinal = scart.find(data=>data!='?')
        const fetchScartId = String(scartFinal).split('&')
        const emailAddress = { "email": email, sessionId: (fetchScartId&&fetchScartId.length) ? fetchScartId[0] : ""}
        props.validateEmail({ payload: emailAddress, fromsaveCartValidation: true })

    }
    const disabled = ( error || !recaptchaValue) ? true : false;
    const showsaveCart = CheckAEMBoolValue(t("fios.enableSaveCartModal",{ns:'fios'}))
    const saveCartValidated = localStorage.getItem('SAVE_CART_EMAIL_VALIDATED')
    if (!(props.emailValidation || saveCartValidated) && showsaveCart && window.location.search && 
    (window.location.search.includes('cid') || window.location.search.includes('scartid')) && !window.location.search.includes('fiosreferral')) {
        return (
            <>
                {props.toggleLoadingSpinner ? <SpinnerComponent /> : <></>}
                <Modal opened={true} disableOutsideClick closeButton={<></>}>
                    <ModalTitle>Verify your information</ModalTitle>
                    <ModalBody>
                        <div>
                            <Body size='large'>Please enter your details below to validate and review your saved cart.</Body>
                            <MarginSpacerM />
                            <Input label="Email"
                                error={error}
                                errorText={errorText}
                                placeholder="Enter your email"
                                onChange={(e) => validateEmail(e.target.value)}
                                value={email}
                                type="text"
                            />
                            <MarginSpacerM />
                            <Captcha setRecaptchaValue={setRecaptchaValue} />
                            <MarginSpacerM />
                            <Button disabled={disabled} onClick={() => { handleContinue() }}>Verify</Button>
                        </div>
                    </ModalBody>
                </Modal>
            </>
        );
    } else return props.children
};



const Captcha = ({ setRecaptchaValue = () => { } }) => {
    const recaptchaRef = React.useRef(null);
    return (
        <ReCAPTCHA
            ref={recaptchaRef}
            // size="invisible"
            sitekey={GOOGLE_RECAPTCHA_SITEKEY}
            onChange={(e) => {
                console.log(e);
                const recaptchaValue = recaptchaRef.current.getValue();
                setRecaptchaValue(recaptchaValue)

            }}
            onExpired={() => { setRecaptchaValue('') }}
        />
    )
}
const mapDispatchToProps = (dispatch) => {
    return {
        validateEmail: (data) => dispatch(validateEmail(data))
        // add your dispatch actions here
    };
};
const mapStateToProps = (state) => {
    const { CustomizeOrder, AddressValidationPage } = state
    return {
        emailValidation: AddressValidationPage.emailValidationSaveCart,
        toggleLoadingSpinner: AddressValidationPage.toggleLoadingSpinner
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SaveCartValidationModal);